<div
	class="gap-3 mt-4 sm:items-center sm:flex sm:mt-0 sm:flex-shrink-0"
	[ngClass]="{
		'grid grid-cols-1': showOnlyOneBtn(),
		'grid grid-cols-2': showTwoBtns(),
		'pt-4': version() === 'desktop',
		'sm:pl-4': version() !== 'desktop',
		'sm:grid-cols-3': showAllBtns(),
	}"
>
	<!-- call uni if register interest is not enabled -->
	@if (showCallBtnOnDesktopIfNoRegisterInterest()) {
		<uc-call-uni-btn
			class="sm:w-full"
			customStyles="block w-full"
			buttonText="Call University"
			mobileButtonText="Call University"
			[phoneNumber]="phoneNumber() ?? ''"
			[uniId]="uniId()"
			[uniName]="uniName()"
			[source]="sourceType() === 'course' ? courseName() : uniName()"
			[sourceType]="sourceType()"
			componentName="Course Listing"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
		/>
	}
	@if (isFeaturedRegisterInterest()) {
		<uc-register-interest-btn
			[uniId]="uniId()"
			sourceType="uni"
			class="sm:w-full"
			customStyles="block w-full"
			componentName="Course Listing"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
		/>
	}
	@if (externalUrl() && isFeatured()) {
		<!--
		(mobile) visit website
		(desktop) if neither register interest or call btns present
	-->
		<uc-clearing-visit-website-btn
			class="sm:w-full sm:hidden"
			[ngClass]="{
				'lg:block':
					!isFeaturedRegisterInterest() && !isFeaturedCalls() && phoneNumber(),
			}"
			customStyles="block w-full !text-sm !py-3"
			[externalUrl]="externalUrl()"
			componentName="Course Listing"
			[uniId]="uniId()"
			buttonText="Visit Website"
			[source]="sourceType() === 'course' ? courseName() : uniName()"
			[sourceType]="sourceType()"
			[uniName]="uniName()"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
			[privacyPolicyUrl]="privacyPolicyUrl()"
			data-cy="visit-website-btn-mobile"
		/>

		<!--
		(desktop) visit website,
		hidden if neither register interest or call btns present
	-->
		<uc-clearing-visit-website-btn
			class="hidden sm:w-full sm:block"
			[ngClass]="{
				'lg:hidden':
					!isFeaturedRegisterInterest && !isFeaturedCalls && phoneNumber,
			}"
			customStyles="sm:block w-full !text-sm !py-3"
			[externalUrl]="externalUrl()"
			componentName="Course Listing"
			[uniId]="uniId()"
			[buttonText]="version() === 'desktop' ? 'Visit Website' : 'Website'"
			[source]="sourceType() === 'course' ? courseName() : uniName()"
			[sourceType]="sourceType()"
			[uniName]="uniName()"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
			[privacyPolicyUrl]="privacyPolicyUrl()"
			data-cy="visit-website-btn-desktop"
		/>
	}
	@if (courseId() && version() === 'mobile') {
		<uc-bookmark
			class="hidden sm:block"
			[saved]="isCourseSaved()"
			[id]="courseId()"
			[uniName]="uniName()"
			[courseSlug]="courseSlug()"
			[academicYear]="academicYear()"
			[delta]="2"
			[showDesktopOnMobile]="true"
			componentName="Course Listing"
			[product]="clearing"
			[bookmarkHeartIcon]="true"
			[ugSearchOrderPosition]="null"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
		/>
	}
</div>
